<template>
    <div
        class="l-ss-c-completions-offer-group"
        :class="{ 'l-ss-c-completions-offer-group-grid': isGridView }"
        ref="offerGroup">
        <h2
            v-if="offersLabel === 'extraOffers'"
            class="l-ss-c-completions-offer-group-title">
            {{ $t('results.extraOffersTitle') }}
        </h2>

        <div
            class="l-ss-c-completions-offer-group-inner"
            :key="offerLayout"
            :style="style">
            <div
                class="l-ss-c-completions-offer-item-wrapper"
                v-for="(offer, i) in currentOffers"
                :key="offer.id">
                <offer
                    :is-cart-count-available="$configuration.cartCount.completions.count"
                    :link-target-blank="$configuration.linkTargetBlank"
                    :mobile="$screen.isMobile"
                    :layout="offerLayout"
                    :settings="$configuration.offer"
                    :data-id="offer._id"
                    :data-position="i + 1"
                    :offer="offer"
                    :offer-index="i"
                    @add-to-cart-click="addToCard($event)"
                    @remove-from-cart-click="removeFromCard($event)"
                    @add-to-favourites-click="addToFavourites($event)"
                    @remove-from-favourites-click="removeFromFavourites($event)"/>
            </div>

            <div
                class="l-ss-c-completions-offer-item-wrapper-empty"
                style="height: 100%"
                v-if="offers.length % 2 === 0 && $screen.isMobile">
            </div>
        </div>
    </div>
</template>

<script>
    import Offer from '@/core/components/offer/offer.vue';

    import getCurrentBreakpoint from '@/core/helpers/get-current-breakpoint';

    export default {
        name: 'completions-item-offer-wrapper',
        components: { Offer },
        props: {
            offers: {
                type: Array,
                required: true,
            },
            offerDataset: {
                type: Object,
            },
            offersLabel: {
                type: String,
            },
            query: {
                type: String,
                default: '',
            },
            hasLeftSection: {
                type: Boolean,
            },
        },
        data() {
            return {
                currentBreakpoint: {
                    columnCount: 1,
                },
            };
        },
        computed: {
            currentOffers() {
                const rowCount = this.currentBreakpoint.rowCount;
                if (rowCount) {
                    return this.offers.slice(0, this.currentBreakpoint.rowCount * this.currentBreakpoint.columnCount);
                }

                return this.offers;
            },
            offerLayout() {
                const placesForLayout = this.$configuration.placesForOfferLayout;
                return this.currentBreakpoint.offerLayout ||
                    (!this.$screen.isMobile ?
                        placesForLayout.completions :
                        placesForLayout.mobileCompletions);
            },
            isGridView() {
                return this.currentBreakpoint.columnCount > 1 || this.$screen.isMobile;
            },
            isAllowBreakpoints() {
                return this.$configuration.layout.completionsBreakpoints && !this.$screen.isMobile;
            },
            style() {
                if (this.isGridView && this.isAllowBreakpoints) {
                    return {
                        display: 'grid',
                        gridTemplateColumns: `repeat(${this.currentBreakpoint.columnCount}, 1fr)`,
                        gridGap: this.currentBreakpoint.gridGap ? `${this.currentBreakpoint.gridGap}px` : '',
                        rowGap: this.currentBreakpoint.rowGap ? `${this.currentBreakpoint.rowGap}px` : '',
                    };
                }

                return null;
            },
        },
        watch: {
            hasLeftSection() {
                if (this.isAllowBreakpoints) {
                    this.setCurrentBreakpoint();
                }
            },
        },
        created() {
            if (this.isAllowBreakpoints) {
                this.setCurrentBreakpoint();
                window.addEventListener('resize', this.setCurrentBreakpoint);
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setCurrentBreakpoint);
        },
        methods: {
            setCurrentBreakpoint() {
                const breakpoint = getCurrentBreakpoint(
                    this.$configuration.layout.completionsBreakpoints,
                    window.innerWidth);

                if (breakpoint) {
                    if (this.hasLeftSection) {
                        this.currentBreakpoint = breakpoint.withLeftSection;
                    } else {
                        this.currentBreakpoint = breakpoint.withoutLeftSection;
                    }
                }
            },
        },
    };
</script>
